import React, { useState } from 'react';
import { routes } from '../../../../assets/routes';
import { generatePath, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Card from '../Card';
import styles from './styles.module.scss';
import first from '../../../../assets/icons/gold_medal.png';
import second from '../../../../assets/icons/silver_medal.png';
import third from '../../../../assets/icons/bronz_medal.png';
import Divider from '@material-ui/core/Divider';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import Loader from '../../Loader';
import AvatarReco from '../../AvatarReco';
import classNames from 'classnames';
import { useQuery } from '@tanstack/react-query';
import { getTopReceiversRequest, getTopSendersRequest } from './api';
import { useTranslation } from '../../../../i18n/LanguageProvider';

function LeaderBoard(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [topKudosReceiver, setTopKudosReceiver] = useState(true);
  const medals = [first, second, third];
  const handleClick = (id) => {
    history.push(generatePath(routes.PROFILE, { id: id }));
  };

  const { isLoading: topSendersIsLoading, data: topSendersData } = useQuery(
    ['topSenders', props.cardId, props.generalOrOrgValues],
    () =>
      getTopSendersRequest({
        card_id: props.cardId,
        sum_of_values: props.generalOrOrgValues
      }),
    {
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );

  const { isLoading: topReceiversIsLoading, data: topReceiversData } = useQuery(
    ['topReceivers', props.cardId, props.generalOrOrgValues],
    () =>
      getTopReceiversRequest({
        card_id: props.cardId,
        sum_of_values: props.generalOrOrgValues
      }),
    {
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );

  const rowTable = (top, i, count) => {
    return (
      <>
        <div className={styles.pics}>
          <AvatarReco
            avatar={top.user.avatar?.thumbnail}
            onClick={() => {
              handleClick(top.user.id);
            }}
            size={4}
          />
          <div
            onClick={() => {
              handleClick(top.user.id);
            }}
            className={styles.name}
          >{`${top.user.first_name} ${top.user.last_name}`}</div>
          {i < 3 ? <AvatarReco size={4} avatar={medals[i]} /> : null}

          <div
            className={
              i === 0
                ? styles.gold
                : i === 1
                ? styles.silver
                : i === 2
                ? styles.bronze
                : styles.others
            }
          >
            <div className={styles.score}>{top.value}</div>
          </div>
        </div>
        {i !== count - 1 ? <Divider /> : null}
      </>
    );
  };
  const mobileView = (topReceiversData, topSendersData) => {
    return (
      <>
        <Card extraClass={styles.wrapper} noPointer>
          <div className={styles.groupButton}>
            <ButtonGroup size="small">
              <Button
                color="primary"
                onClick={() => {
                  setTopKudosReceiver(true);
                }}
                variant={!topKudosReceiver ? 'outlined' : 'contained'}
              >
                {t('leaderboard.receiver')}
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  setTopKudosReceiver(false);
                }}
                variant={topKudosReceiver ? 'outlined' : 'contained'}
              >
                {t('leaderboard.sender')}
              </Button>
            </ButtonGroup>
          </div>
          <div className={styles.info}>
            {topKudosReceiver
              ? topReceiversData?.map((top, i) =>
                  rowTable(top, i, topReceiversData.length)
                )
              : topSendersData?.map((top, i) =>
                  rowTable(top, i, topSendersData.length)
                )}
          </div>
        </Card>
      </>
    );
  };
  const desktopView = (tops, nameTable) => {
    return (
      <>
        <Card extraClass={styles.wrapper_desktop} noPointer>
          <h4>{nameTable}</h4>

          <div className={styles.info}>
            {tops?.map((top, i) => rowTable(top, i, tops.length))}
          </div>
        </Card>
      </>
    );
  };
  return (
    <>
      {!topReceiversIsLoading && !topSendersIsLoading ? (
        topSendersData.length ? (
          props.isDesktop ? (
            <>
              {desktopView(topReceiversData, t('leaderboard.receivers'))}
              {desktopView(topSendersData, t('leaderboard.senders'))}
            </>
          ) : (
            <>{mobileView(topReceiversData, topSendersData)}</>
          )
        ) : (
          <div className={classNames(styles.emptyCard, styles.leaderBoard)}>
            {t('leaderboard.empty')}
          </div>
        )
      ) : (
        <Loader />
      )}
    </>
  );
}

LeaderBoard.propTypes = {
  isDesktop: PropTypes.bool,
  cardId: PropTypes.number || null,
  generalOrOrgValues: PropTypes.bool
};

export default LeaderBoard;
